export const constants = {
  'Resources': {
    LblPWelcomeTxt: 'Welcome To',
    LblPreviewPdf:'Generate PDF',
    LblPreviewWord:'Edit Word',
    LblEditMeeting:'Edit Meeting',
    LblDeleteMeeting:'Delete Meeting',
    LblCopyMeetingLink:'Copy Meeting Link',
    LblPSubHeading: 'Fill out the form to get started.',
    LblPHavingAccount: 'Have an account?',
    LblFPEmail: 'Please provide email id to reset the password.',
    LblEmailSent: 'Email sent successfully.',
    LblPasswordChanged: 'Password changed successfully.',
    LblLogin: 'Login',
    LblJoinMeeting: 'Join Meeting',
    LblJoin: 'Join',
    LblMeetingID: 'Meeting ID',
    LblEditBio:'Edit Bio',
    LblSignup: 'Get Started',
    LblUpdateDetails: 'Update Details',
    LblFirstName: 'First Name',
    LblAmount:'Amount',
    LblSendPaymentLink:'Send Payment Link',
    LblLastName: 'Last Name',
    LblEmail: 'Email',
    LblMobileNo: 'Mobile No.',
    LblAddress: 'Address',
    LblDOB: 'Date Of Birth',
    LblPreferredCurrency: 'Preferred Currency',
    LblSex: 'Sex',
    LblAge:'Age',
    LblDiagnosis:'Diagnosis',
    LblApplyForDrug:'Apply For Drug',
    LblDosage:'Dosage',
    LblMaritalStatus: 'Marital Status',
    LblEmergencyContactName: 'Emergency Contact Name',
    LblRelationship: 'Relationship',
    LblPatientLogin: 'If you are a PATIENT click here',
    LblClicianLogin: 'If you are a CLINICIAN click here',
    LblConsultantLogin: 'If you are an ADVISOR / CONSULTANT click here',
    LblAltMobileNo: 'Alternative Number',
    LblDegree: 'Degree',
    LblPreviousTraining: 'Previous Training',
    LblYearInService: 'Year In Service',
    LblFeesPerCase: 'Fees per case',
    LblPhotoUpload: 'Photo Upload',
    LblUpdate: 'Update',
    LblPassword: 'Password',
    LblConfirmPassword: 'Confirm Password',
    LblEmailAddress: 'Email Address',
    LblEmailAddressPhone: 'Email Address/Mobile No.',
    LblDragDrop: 'Drag & Drop',
    LblConsulationNotes: 'Consulation Notes',
    LblPathology: 'Pathology',
    LblScanReport: 'Scan Report',
    LblClinicalDetails: 'Clinical Details',
    LblLabReports: 'Lab Reports',
    LblGenomicReports: 'Genomic Reports',
    Lb1PathologyImages:'Pathology Images',
    LblGenomicFiles:'Genomic Files',
    LblImagingVideos:'Imaging Videos',
    LblAdditionalReports: 'Additional Reports',
    LblPatientDetails: 'Patient Details',
    LblDischargeSummary: 'Discharge Summary',
    LblOldCaseRef: 'Old Case Ref',
    LblCancerType: 'Cancer Type',
    LblAlerts: 'Alerts',
    LblPatientRegistered: 'Patient registered successfully.',
    LblClinicianRegistered: 'Clinician registered successfully.',
    LblConsultantRegistered: 'Consultant registered successfully.',
    LblAdminCreated: 'Admin registered successfully.',
    LblSuperAdminRegistered: 'SuperAdmin registered successfully.',
    LblOk: 'Ok',
    LblSummary: 'Summary',
    LblActiveCase: 'Active Cases',
    LblSubmitCase: 'Submit Case',
    LblSubmitbutton: 'Submit',
    LblAddAdmin: 'Add Admin',
    LblAddConsultant: 'Add Consultant',
    LblAddClinician: 'Add Clinician',
    LblAddSuperadmin: 'Add Superadmin',
    LblSubmit: 'Submit Final Case',
    LblNewCaseCreated: 'New Case Created.',
    LblCaseUpdate: 'Case Updated.',
    LblEdit: 'Edit',
    LblView: 'View',
    LblDelete: 'Delete',
    LblPayFees: 'Pay Fees',
    lblPaid: 'Paid $',
    LblSendBackToPatient: 'Send Back To Patient',
    LblReassignConsultant: 'Reassign Consultant',
    LblReasignClinician: 'Reassign Clinician',
    LblassignConsultant: 'Assign Consultant',
    LblasignClinician: 'Assign Clinician',
    LblUserAddEmailLinkText: `We have sent a verification link to the user's email. Once the user verifies their email, they will be able to log in to the system.`,
    LblReasignBtn: 'Reassign Case',
    LblAddMyNotes: 'Add Final Notes',
    LblRecommendation: 'Recommendation',
    LblAddNotes: 'Add Notes',
    LblSendCaseToConsultant: 'Send Case To Consultant',
    LblCaseAssignedToConsultant: 'Case Assigned To Consultant',
    LblVoiceSubmitted:"Voice Notes Submitted Successfully",
    LblDocuSignSent:"We have sent you an email to take your consent. Please E-Sign the document and then rejoin.",
    LblEditCase: 'Edit Case',
    LblViewCaseFile: 'View Files',
    LblDeleteCase: 'Delete Case',
    LblPlaceHolderSelect: '- Select -',
    LblAssignClinician: 'Assign Clinician',
    LblEmergencyContactNo: 'Emergency Contact No.',
    LblUsers: 'Users',
    LblCaseUpdated: 'Case Updated',
    LblCaseAssignToClinician:'Case Assigned To Clinician',
    LblCaseAssignToConsutlant:'Case Assigned To Consultant',
    LblNoDataFound: 'No Data Found',
    LblAddUser: 'Add User',
    LblRole: 'Role',
    LblUserCreated: 'User Created Successfully.',
    LblAccept: 'Accept Case',
    LblReject: 'Reject Case',
    LblNeedMoreInfo: 'Need More Info',
    LblSendToAdmin: 'Send To Admin',
    LblRejectConfirmation: 'Are you sure you want to reject the case?',
    lblWelcome: 'Welcome',
    LblPatients: 'Patients',
    LblAddPatient: 'Add Patient',
    LblCaseId:'Case ID',
    LblIylonConnect: 'Iylon Connect',
    LblIylonConnectPayment: 'Iylon Connect Payment',
    LblPatientUpdated: 'Patient Updated',
    LblClinicianUpdated: 'Clinician Updated',
    LblConsultantUpdated: 'Consultant Updated',
    LblAdminUpdated: 'Admin Updated',
    LblSuperAdminUpdated: 'Super Admin Updated',
    LblDeleteUserConfirmation: 'Are you sure you want to delete the user?',
    LblDeleteMeetingConfirmation: 'Are you sure you want to delete this Meeting?',
    LblDeleteCaseConfirmation: 'Are you sure you want to delete the case?',
    LblPatientComments: 'Patient Comments',
    LblOthers: 'Others',
    LblImagingReport: 'Imaging Report',
    LblHospital: 'Hospital',
    LblProfile: 'Profile',
    LblLogout: 'Logout',
    LblFinalNotes: 'Final Notes',
    LblSaveNotes: 'Save Notes',
    LblSave: 'Save',
    LblSaveRecommendation: 'Save Recommendation',
    LblPatient: 'Patient',
    LblPUpdateSubHeading: 'Update the details:',
    LblCancel: 'Cancel',
    LblSend: 'Send',
    LblSubmitedToAdmin: 'Case Submitted to admin',
    LblSubmitedToPatient: 'Case Submitted to patient',
    LblAdminLogin: 'Super admin/Admin',
    LblSubmited: 'Submitted Successfully',
    LblCreateCase: 'Submit New Case',
    LblUpdateCase: 'Update Case',
    lblReviewCasePDF: 'Review Case PDF',
    LblClinicianComments: 'Clinician Comments',
    LblReports: 'Reports',
    LblPleaseAccept: 'I have read and agree to ',
    lblConfirmReadTnC: 'I confirm that I have read the ',
    LblTermnCondtionsHeader: 'Term & Conditions',
    LblTermnCondtions: 'Iylon\'s Terms and Conditions',
    lblTermPrivacyPolicy: 'Privacy Policy',
    lblTermHipaPolicy: 'HIPAA Policy',
    lblTermClinicianAgreement: 'Clinicians Agreement',
    lblAndWord: 'and',
    LblWeight: 'Weight',
    LblHeight: 'Height',
    LblBSA: 'BSA',
    LblSendOtp: 'Send Authentication code',
    LblReSendOtp: 'Resend OTP',
    LblVerifyOtp: 'Verify OTP',
    LblOTP: 'Please enter Authentication code',
    LblEditProfile: 'Edit Profile',
    LblUSD: 'USD',
    LblSalutation: 'Salutation',
    LblCancerCTxt: 'Cancer is a devastating disease and cancer treatment is evolving every day.  While each one of us is delivering the best care possible for the cancer patients, together, by discussing the cancer type, mutation, and other potential vulnerabilities, we can combat cancer and help cancer patients to lead a normal life. Together, we can defeat this enemy.',
    LblPatientCTxt: 'We are sorry you are going through this challenging time. We are here to help you get the best in class medical recommendation from world class oncologists. ',
    LblUpdateAddress: 'Update',
    LblAddress1: 'Address Line 1',
    LblAddress2: 'Address Line 2',
    LblTown: 'Town',
    LblPostcode: 'Post Code',
    LblCountry: 'Country',
    LblCounty: 'County',
    LblAreaOfSpecialization: 'Area of Specialization',
    LblDiseaseSpecialization: 'Disease Specialization',
    LblClinician: 'Clinician',
    LblConsultant: 'Consultant',
    LblShortBio: 'Short Bio',
    LblUserUpdated: 'User Updated',
    LblPosition: 'Position',
    LblAlternativeNumber: 'Alternative Number',
    LblRegisterBy: 'Register By',
    LblRegister: 'Register',
    LblRegisteredSuccesfully: 'Registered Successfully.',
    LblDontSendToPatient: 'Don\'t send to patient',
    LblSummaryCasePDF: 'Summary Case PDF',
    LblApprove: 'Approve',
    LblApproved: 'Approved',
    LblRegistrationBy: 'Registration by',
    LblCancerCTxt2: 'Iylon is looking for Oncologists to represent cancer patients to International Experts. If you are interested in being an Iylon Precision Oncologist please register here.',
    LblOther: 'Other',
    LblAddCaseSummary: 'Add Case Summary',
    LblCaseSummary: 'Case Summary',
    LblCaseSummarySubmited: 'Case Summary Submitted.',
    LblCaseSummarySaved: 'Case Summary Saved.',
    LblChangePassword: 'Change Password',
    LblAddAffiliate: 'Add Affiliate',
    LblName:'Name',
    LblDiscount:'Discount%',
    LblMarkup:'Markup%',
    LblCouponCode:'Coupon Code',
    LblAffiliateUpdated:'Affiliate Updated',
    LblAffiliateRegistered:'Affiliate Registered',
    LblAffiliateList:'Affiliates',
    LblDeleteAffiliateConfirmation: 'Are you sure you want to delete Affiliate',
    LblAffiliateId: 'Affiliate Id',
    LblSignUpLink: 'Patient Sign Up Link',
    LblRegenerateCouponCode: 'Regenerate Coupon Code',
    LblCouponGenerated:'Coupon Code Regenerated',
    LblmakePrimary:'Phone Number Updated',
    LblDownloadInvoice:'Download Invoice',
    LblRegenerateCasePDF:'Regenerate Case PDF',
    LblViewRedactCasePDF:'View Redact Case PDF',
    LblRegenerateCaseSummaryPDF:'Regenerate Case Summary',
    LblSelectConsultant: 'Select Consultant',
    LblSelectPatient: 'Select Patient',
    LblPaymentStatus:' Check Payment Status',
    LblViewCaseFiles:'View Case Files',
    LblVirtualConsultation:'Virtual Consultation',
    LblVirtualConsultationDone:'Virtual Consultation Done ?',
    LblGeneratePayPalPaymentLink: 'Generate PayPal Payment Link',
    LblConsulationNotesFormats:"Consulation Notes (.pdf & .jpeg formats allowed)",
    LblImagingReportFormats:'Imaging Report (.pdf & .jpeg formats allowed)',
    LblPathologyFormats: 'Pathology (.pdf & .jpeg formats allowed)',
    LblClinicalDetailsFormats:'Clinical Details (.pdf & .jpeg formats allowed)',
    LblLabReportsFormats:'Lab Reports (.pdf & .jpeg formats allowed)',
    LblGenomicReportsFormats:'Genomic Reports (.pdf & .jpeg formats allowed)',
    LblGenomicFilesFormats:'Genomic Files (dicom & video formats allowed)',
    Lb1PathologyImagesFormats:'Pathology Images (.pdf & .jpeg formats allowed)',
    LblImagingVideosFormats:'Imaging Videos (dicom & video formats allowed)',
    LblOthersFormats:'Others (.pdf & .jpeg formats allowed)',
    LblDischargeSummaryFormats:'Discharge Summary (.pdf & .jpeg formats allowed)',
    LblPatientCaseDetails: "Patient Case Details"
    

  },
  'SESSION_EXPIRED': 'Unauthorized',
  'AUTHENTICATION_CODE': 'Authentication code'
};

